// import { Component, OnInit } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Component, ViewChild, AfterViewInit, NgModule, Inject, OnInit} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTable } from '@angular/material/table';
import {merge, Observable, of as observableOf} from 'rxjs';
import {catchError, map, startWith, switchMap} from 'rxjs/operators';
import { MatTableDataSource } from '@angular/material/table';
import { BrowserModule } from '@angular/platform-browser';
import { HttpService } from '../../http.service';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MatSnackBar} from '@angular/material/snack-bar';
import { AuthenticationService } from '../../_services';
import { EntradaService } from '../../_services';
import { first } from 'rxjs/operators';
import { Router } from '@angular/router';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatStepperModule} from '@angular/material/stepper';
import { FulfillmentService } from '../../_services';
import { environment } from 'src/environments/environment';

interface EntradasStatus {
  value: string;
  viewValue: string;
}

const mexicoCityDateTimeFormatter = new Intl.DateTimeFormat('es-MX', {
  timeZone: 'America/Mexico_City',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
});

const mexicoCityDateFormatter = new Intl.DateTimeFormat('es-MX', {
  timeZone: 'America/Mexico_City',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
});

const mexicoCityTimeFormatter = new Intl.DateTimeFormat('es-MX', {
  timeZone: 'America/Mexico_City',
  hour: '2-digit',
  minute: '2-digit',
});

function formatMexicoDateTime(value?: string | null): string {
  if (!value) {
    return '—';
  }

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return value;
  }

  return mexicoCityDateTimeFormatter.format(parsed);
}

function formatMexicoDate(value?: string | null): string {
  if (!value) {
    return '—';
  }

  const dateMatch = String(value).match(/(\d{4})-(\d{2})-(\d{2})/);
  if (dateMatch) {
    return `${dateMatch[3]}/${dateMatch[2]}/${dateMatch[1]}`;
  }

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return value;
  }

  return mexicoCityDateFormatter.format(parsed);
}

function formatMexicoTime(value?: string | null): string {
  if (!value) {
    return '—';
  }

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    const timeMatch = String(value).match(/(?:T|\b)(\d{2}:\d{2})(?::\d{2})?/);
    return timeMatch ? timeMatch[1] : value;
  }

  return mexicoCityTimeFormatter.format(parsed);
}

function normalizeTimeForBackend(value?: string | Date | null): string | null {
  if (!value) {
    return null;
  }

  if (value instanceof Date) {
    const hours = String(value.getHours()).padStart(2, '0');
    const minutes = String(value.getMinutes()).padStart(2, '0');
    return `${hours}:${minutes}`;
  }

  const trimmed = String(value).trim();
  if (!trimmed) {
    return null;
  }

  const timeMatch = trimmed.match(/(?:T|\b)(\d{2}:\d{2}(?::\d{2})?)/);
  return timeMatch ? timeMatch[1] : null;
}

@Component({
  selector: 'app-entradas',
  templateUrl: './entradas.component.html',
  styleUrls: ['./entradas.component.scss']
})
export class EntradasComponent implements OnInit {
  user: any;
  seller_id: any;
  deshabilitado = false;
  current_user: any;
  constructor(
    private authenticationService: AuthenticationService,
  ) { }

  ngOnInit() {
    this.authenticationService.currentUser.subscribe(x => this.user = x);
    if(this.user){
      if(this.user["seller_id"] == 3){
        this.deshabilitado = true;
      }
    }
    this.asignarDatos();
  }
  asignarDatos(){
    this.current_user = this.authenticationService.currentUserValue

  }
  validar_roles(clave_modulo){
    return this.authenticationService.validar_roles(clave_modulo,this.current_user.permisos);
  }

}


@Component({
  selector: 'entradas-tab-1',
  templateUrl: './entradas-tab-1.html',
  styleUrls: ['./entradas.component.scss']

})
export class EntradasTab1 implements AfterViewInit {

  displayedColumns: string[] = ['entrada_token', 'estatus', 'fecha_estatus', 'substatus', 'substatus_date_time', 'cargar_guia', 'editar_orden','ver_orden'];
  entradaDatabase: EntradaDatabase | null;
  data: EntradaIssue[] = [];

  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;
  guiaForm: FormGroup;
  keywords = "";
  hay_datos = true;
  titulo_diff = false;
  datos_iniciales = true;
  on_proces = false;
  current_user: any;

  entrada_status: FormControl =  new FormControl('', []);

  entradas_status: EntradasStatus[] = [
    {value: 'abierta', viewValue: 'Abierta'},
    {value: 'proceso', viewValue: 'En proceso'},
    {value: 'closed', viewValue: 'Cerrada'},
    {value: 'reabierta', viewValue: 'Re-abierta'},
    {value: 'agendado', viewValue: 'Agendado'},
    {value: 'cancelada', viewValue: 'Cancelada'}
  ];


  constructor(
      private formBuilder: FormBuilder,
      private _httpClient: HttpClient,
      public dialog: MatDialog,
      private entradaService: EntradaService,
      private router: Router,
      private authenticationService: AuthenticationService,
  ) { }

  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: false}) sort: MatSort;



  ngAfterViewInit() {


    this.entradaDatabase = new EntradaDatabase(this._httpClient);

    // If the user changes the sort order, reset back to the first page.
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

    // console.log("las keywords iniciales son " + this.keywords)
    this.hacerTabla(this.keywords);



  }
  ngOnInit() {
    this.asignarDatos();

  }
  asignarDatos(){
    this.current_user = this.authenticationService.currentUserValue

  }
  validar_roles(clave_modulo){
    return this.authenticationService.validar_roles(clave_modulo,this.current_user.permisos);
  }
  setClasses() {


    let myClasses = {
     // retrasado: Date.parse(fecha_corte.toISOString()) > Date.parse(fecha_creado),
     // a_tiempo: Date.parse(fecha_corte.toISOString()) < Date.parse(fecha_creado),
    }

    return  myClasses
  }

  mostrarCard(){
    if(this.datos_iniciales){
      this.titulo_diff = true;
    }else{
      this.titulo_diff = false;
    }
    this.hay_datos = !this.hay_datos;
  }

  applyFilterEntradas(){
    this.hacerTabla(this.keywords);
  }

  hacerTabla(filtros){
    merge(this.sort.sortChange, this.paginator.page, )
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          return this.entradaDatabase!.getRepoIssues(
            this.sort.active, this.sort.direction, this.paginator.pageIndex, this.keywords, this.entrada_status.value);
        }),
        map(data => {
          // Flip flag to show that loading has finished.
          this.isLoadingResults = false;
          this.isRateLimitReached = false;
          this.resultsLength = data.total_count;
          // console.log("vamos en la 72")
          // console.log(data)
          if(data.items.length == 0) {
            this.hay_datos = false
            this.datos_iniciales = false
          }else{
            this.hay_datos = true
            this.datos_iniciales = true
          }

          return data.items;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          // Catch if the GitHub API has reached its rate limit. Return empty data.
          this.isRateLimitReached = true;
          return observableOf([]);
        })
      ).subscribe(data => this.data = data);
  }

  estatus_entrada(entrada){
    if (entrada.status) {
      return entrada.status.toUpperCase();
    } else {
      return "SIN STATUS";
    }
  }

  fecha_estatus(devolucion){
    return devolucion.status_date_time || null;
  }

  formatMexicoDateTime(value: string | null): string {
    return formatMexicoDateTime(value);
  }

  formatMexicoDate(value: string | null): string {
    return formatMexicoDate(value);
  }

  formatMexicoTime(value: string | null): string {
    return formatMexicoTime(value);
  }


  //  PARA DIALOGO GUIAS
  openDialog(entrada_token) {
    // console.log("Entro a dialog guia")

    //// console.log(correo)
    const dialogRef = this.dialog.open(DialogGuia ,{width:'450px', height: 'auto', data: {token: entrada_token}});

    dialogRef.afterClosed().subscribe(result => {
      // console.log("Cerramos el dialog");
      this.hacerTabla(this.keywords);
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.keywords = filterValue.trim().toLowerCase();
    // console.log("las keywords son ")
    // console.log(this.keywords)
    this.hacerTabla(this.keywords);
  }

  consultarEntrada(entrada_token){
    this.router.navigate(['/entradas/ver', entrada_token]);
  }

  // Nuevo método para abrir el diálogo de edición
  abrirDialogoEdicion(entrada_token: string) {
    // Primero validar si es editable
    this.entradaService.validarEntradaEditable(entrada_token)
      .pipe(first())
      .subscribe(
        data => {
          if (data.status === 200 && data.body) {
            const validacion = data.body;
            
            if (validacion.editable) {
              // Abrir diálogo de edición
              const dialogRef = this.dialog.open(DialogEditarEntrada, {
                width: '900px',
                maxHeight: '90vh',
                disableClose: false,
                data: {
                  entrada_token: entrada_token,
                  permisos: validacion.permisos
                }
              });
              
              dialogRef.afterClosed().subscribe(result => {
                if (result) {
                  // Recargar datos si hubo cambios
                  this.hacerTabla(this.keywords);
                }
              });
            } else {
              // Mostrar mensaje informativo
              this.mostrarMensaje(validacion.mensaje, 'info');
            }
          }
        },
        error => {
          this.mostrarMensaje('Error al validar entrada', 'error');
        }
      );
  }

  mostrarMensaje(mensaje: string, tipo: string) {
    const duration = tipo === 'error' ? 5000 : 4000;
    const panelClass = tipo === 'error' ? ['error-snackbar'] : ['info-snackbar'];
    // Usamos MatSnackBar si está disponible, sino alert
    alert(mensaje);
  }

  apoyoEntrada(entrada_token){
    // console.log("entrada es "+entrada_token)
    this.on_proces = true;
    this.entradaService.mandarApoyoEntrada(entrada_token)
    .pipe(first())
    .subscribe(
      data => {
        if(data["result"] == 200){
          this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
              this.router.navigate(['/entradas']);
          });
        }
      },
      error => {
    });
  }

}

export interface EntradabApi {
  items: EntradaIssue[];
  total_count: number;
}

export interface EntradaIssue {
  entrada_token: string;
  fecha_creada: string;
  fecha_de_llegada: string;
  fecha_de_inicio_entrada: string;
  arrival_date?: string;
  arrival_time_start?: string;
  arrival_time_end?: string;
  tracking_number: string;
  carrier_name: string;
  link: string;
  apoyo: boolean;
  status: string;
  status_date_time: string;
  fecha_cerrada: string;
  fecha_reabierta: string;
  substatus: string;
  substatus_date_time: string;
  created_at?: string;
  updated_at?: string;
  editable?: boolean;
  cancelable?: boolean;
  comentario_cancelacion?: string;
}

/** An example database that the data source uses to retrieve data for the table. */
export class EntradaDatabase {
  constructor(private _httpClient: HttpClient) {}

  getRepoIssues(sort: string, order: string, page: number, filtro: string, entrada_status:string): Observable<EntradabApi> {
    // console.log(sort)
    // console.log(order)
    // console.log(page)
     const href = `${environment.apiUrl}/rmsfe/query_entradas.json`;
    // const href = 'http://localhost:3000/rmsfe/query_entradas.json';
    const requestUrl =
        `${href}?sort=${sort}&order=${order}&page=${page + 1}&keywords=${filtro}&estado_entrada=${entrada_status}`;

    return this._httpClient.get<EntradabApi>(requestUrl);
  }
}


export interface EntradabApi2 {
  items: ItemsIssue[];
  total_count: number;
}

export interface ItemsIssue {
  id: number;
  seller_sku: string;
  title: string;
}

export class EntradaDatabaseItems {
  constructor(private _httpClient: HttpClient) {}

  getRepoIssues(filtro: string): Observable<EntradabApi2> {
    const href = `${environment.apiUrl}/rmsfe/listar_items.json`;
    const requestUrl = `${href}?nombre_producto=${filtro}`;
    return this._httpClient.get<EntradabApi2>(requestUrl);
  }
}


export interface ProductosEntrada {
  item_id: number,
  sku: string;
  producto: string;
  cantidad: number;
  ean: string;
  /** Si el ítem es preventa (enviado en nueva_entrada y mostrado en tabla tab-2). */
  presale?: boolean;
}

export interface ShowEntrada {
  id?: number;
  item_id?: number;
  titulo: string;
  seller_sku: string;
  ean: string;
  cantidad_anunciada: number;
  cantidad_recibida: number;
  presale_stock: number;
  presale?: boolean;
  fecha_de_llegada?: string;
  fecha_de_alta?: string;
  checking_quantity_accepted?: number;
  checking_quantity_rejected?: number;
  motivo_rechazo?: string;
  motivo_aceptado?: string;
  evidencias_checking?: any[];
  evidencias_aceptado?: any[];
  checked_by?: string;
  checked_at?: string;
}

export interface EntradaListPayload {
  entrada_token: string;
  fecha_creada?: string;
  fecha_de_llegada?: string;
  fecha_de_inicio_entrada?: string;
  fecha_cerrada?: string;
  fecha_reabierta?: string;
  arrival_date?: string;
  arrival_time_start?: string;
  arrival_time_end?: string;
  status?: string;
  status_date_time?: string;
  substatus?: string;
  substatus_date_time?: string;
  comentario_cancelacion?: string;
  cancelable?: boolean;
}

export interface EntradaShowResponseBody {
  esta_entrada: ShowEntrada[];
  entrada_list: EntradaListPayload;
  seller?: any;
  entrada_token: string;
}

export interface InboundEventsResponseBody {
  status: number;
  entrada_list_id: number;
  entrada_token: string;
  inbound_events: InboundEvent[];
}

@Component({
  selector: 'entradas-tab-2',
  templateUrl: './entradas-tab-2.html',
  styleUrls: ['./entradas.component.scss']

})
export class EntradasTab2 implements OnInit {

  constructor(public dialog: MatDialog,
    private snackBar: MatSnackBar,
    private _httpClient: HttpClient,
    private router: Router,
    private authenticationService: AuthenticationService
    ) {

    }
  breakpoint: number;
  columna1: number;
  columna2: number;
  columna3: number;
  not_found = false;
  entrada_final: [];
  ya_existe: number;
  filterName:string;
  filterCantidad: string;
  entradaDatabase: EntradaDatabaseItems | null;
  isLoadingResults = true;
  isRateLimitReached = false;
  resultsLength = 0;
  keywords = "";
  // data: object;
  dataItems: ItemsIssue[] = [];
  current_user: any;

  // MyArrayType = Array<{sku: string, producto: string, cantidad: number}>;
  entradaFinal:ProductosEntrada[] = [];
  displayedColumns = ['sku', 'ean', 'producto', 'cantidad','preventa', 'action'];
  datos_tabla: ProductosEntrada[] = []

  itemForm = new FormControl('', [
    Validators.required,
  ]);

  cantidadForm = new FormControl('', [
    Validators.required,
    Validators.min(1),
  ]);

  // datos_tabla: ProductosEntrada[] = [];

  options:[
  ];

  // filteredOptions: Observable<[string][]>;
  // filteredOptions: Observable<EntradasTab2[]>;
  filteredOptions: Observable<ItemsIssue[]>;
  ngAfterViewInit() {


    this.entradaDatabase = new EntradaDatabaseItems(this._httpClient);
    // If the user changes the sort order, reset back to the first page.
    // this.hacerAutcomplete();
  }

  ngOnInit() {
    // console.log("Entro a ongit")
    this.asignarDatos();
    this.breakpoint = (window.innerWidth <= 599) ? 1 : 6;
    this.columna1 = (window.innerWidth <= 599) ? 1 : 3;
    this.columna2 = (window.innerWidth <= 599) ? 1 : 2;
    this.columna3 = (window.innerWidth <= 599) ? 1 : 1;
    // this.filteredOptions = this.itemForm.valueChanges
    //   .pipe(
    //     startWith(''),
    //     map(value => this.filterStates(value))
    //   );
    // this.options = ['hola', 'adios'];
    this.entradaDatabase = new EntradaDatabaseItems(this._httpClient);
    // If the user changes the sort order, reset back to the first page.
    this.hacerAutcomplete(this.keywords);
    // console.log("los items son")
    // console.log(this.dataItems)
  }
  asignarDatos(){
    this.current_user = this.authenticationService.currentUserValue

  }
  validar_roles(clave_modulo){
    return this.authenticationService.validar_roles(clave_modulo,this.current_user.permisos);
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.keywords = filterValue.trim().toLowerCase();
    // console.log("las keywords son ")
    // console.log(this.keywords)
    this.hacerAutcomplete(this.keywords);
  }

  // private _filter(value: string): string[] {
  //   const filterValue = value.toLowerCase();

  //   return this.options.filter(option => option.toLowerCase().includes(filterValue));
  // }

  filterStates(s: any) {
    let stateName = s.seller_sku || s; // s can be a State or a string
    return this.dataItems.filter(state =>
      state.seller_sku.toLowerCase().indexOf(stateName.toLowerCase()) === 0);
  }



  hacerAutcomplete(filtros){
    merge()
    .pipe(
      startWith({}),
      switchMap(() => {
        this.isLoadingResults = true;
        return this.entradaDatabase!.getRepoIssues(filtros);
      }),
      map(data => {
        // Flip flag to show that loading has finished.
        this.isLoadingResults = false;
        this.isRateLimitReached = false;
        this.resultsLength = data.total_count;
        // console.log("vamos con los items")
        // console.log(data)
        return data.items;
      }),
      catchError(() => {
        this.isLoadingResults = false;
        // Catch if the GitHub API has reached its rate limit. Return empty data.
        this.isRateLimitReached = true;
        return observableOf([]);
      })
    ).subscribe(data => this.dataItems = data);
  }

  displayFn(subject){
    if(subject){
      if(subject.seller_sku){
        return subject.seller_sku;
      }else if(subject.title){
        return subject.title;
      }
    }else{
      return undefined;
    }

  }

  validarDatos(){
    if(this.itemForm.invalid || this.cantidadForm.invalid){
      return;
    }
    var elItem = this.itemForm.value;
    if(!elItem){
      return;
    }
    // console.log(this.itemForm.value);
    // let itemIndex = this.dataItems.findIndex(x => x.seller_sku === this.itemForm.value);
    // // console.log(" INDX es "+itemIndex)
    // if(itemIndex == -1){
    //   // console.log(this.itemForm.value);
    //   let itemIndex = this.dataItems.findIndex(x => x.title === this.itemForm.value.title);
    //   let itemIndex = this.dataItems
    //   if(itemIndex == -1){
    //     this.itemForm.setErrors({'required': true});
    //     return;
    //    }
    // }
    // // console.log("itemIndex")
    // // console.log(itemIndex)
    // console.log(elItem)
    this.filterName = "";
    this.filterCantidad = "";
    let producto = elItem.title;
    let item_id = elItem.id;
    let el_seller_sku = elItem.seller_sku;
    let ean = elItem.ean;
    if(!(typeof elItem === 'object' && elItem !== null)){
      this.snackBar.open("Debes seleccionar un producto de la lista", "OK", {
        duration: 5000,
      });
      return;
    }

    if(elItem.bundle > 0){
      this.snackBar.open(`EL SKU: ${elItem.seller_sku} es un bundle, por lo tanto, no se le puede generar entrada de inventario`, "OK", {
        duration: 3500,
      });
      return;
    }

    this.addItem(this.entradaFinal, el_seller_sku, this.cantidadForm.value, producto, item_id, ean);
    // this.entradaFinal.push({sku: this.itemForm.value, producto: producto, cantidad: this.cantidadForm.value});
    // // console.log(this.entradaFinal);
    this.datos_tabla = this.entradaFinal;
    this.datos_tabla = this.datos_tabla.filter((value,key)=>{
      return value;
    });
    // console.log("La entrada_final es")
    // console.log(this.entradaFinal)
  }

  addItem(arr, seller_sku, quantity, titulo, item_id, ean) {
    // console.log("arr es" +arr);
    let { length } = arr;
    let id = length + 1;
    let found = arr.some(el => el.item_id === item_id);

    if (!found){
      arr.push({sku: seller_sku, producto: titulo, cantidad: quantity, item_id: item_id, ean: ean, presale: false});
    }else{
      let index = arr.findIndex(x => x.item_id === item_id);
      // console.log("el repetido es el " + index);
      arr[index].cantidad = arr[index].cantidad + quantity;
    }
    return arr;
  }

  onResize(event) {
    this.breakpoint = (event.target.innerWidth <= 599) ? 1 : 6;
    this.columna1 = (window.innerWidth <= 599) ? 1 : 3;
    this.columna2 = (window.innerWidth <= 599) ? 1 : 2;
    this.columna3 = (window.innerWidth <= 599) ? 1 : 1;
  }

  deleteRowData(row_obj){
    this.datos_tabla = this.datos_tabla.filter((value,key)=>{
      return value.sku != row_obj.sku;
    });
    this.entradaFinal = this.datos_tabla;
  }

  enviarEntrada(){
    if(this.datos_tabla.length > 0){
      const dialogRef2 = this.dialog.open(DialogGuia2 ,{width:'800px', minHeight: '600px', height: 'auto', maxHeight: '90vh', disableClose: true ,data: {entrada_final: this.entradaFinal}});

      dialogRef2.afterClosed().subscribe(result => {
        // console.log("Cerramos el dialog 2");
      });
    }else{
      this.snackBar.open("Primero debes agregar productos a la orden de Entrada", "OK", {
        duration: 3500,
      });
    }

  }


  /** Gets the total cost of all datos_tabla. */
  getTotalCost() {
    return this.datos_tabla.map(t => t.cantidad).reduce((acc, value) => acc + value, 0);
  }

}


@Component({
  selector: 'entradas-tab-3',
  templateUrl: './entradas-tab-3.html',
  styleUrls: ['./entradas.component.scss']

})
export class EntradasTab3 implements OnInit {

  isLinear = false;
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  progress = false;
  descargar = false;
  url_descargar = "";
  formFile: FormControl;
  file_name: string;
  fileToUpload: File = null;
  exito = false;
  enviado = true;
  spinner = false;
  dataErrors: EntradaError[] = [];
  hay_datos = true;
  displayedColumns = ['seller_sku', 'title', 'result']

  constructor(private _formBuilder: FormBuilder,
    private entradaService: EntradaService,
    private fulfillmentService: FulfillmentService,
    private snackBar: MatSnackBar,
    private router: Router,
    public dialog: MatDialog
    ) {}

  ngOnInit() {
    this.firstFormGroup = this._formBuilder.group({
      firstCtrl: ['', Validators.required]
    });
    this.secondFormGroup = this._formBuilder.group({
      secondCtrl: ['', Validators.required]
    });
    this.formFile = new FormControl('', Validators.required);
  }

  generarPlantilla(){
    this.progress = true;
    this.entradaService.generarPlantilla()
    .pipe(first())
    .subscribe(
      data => {
        // console.log(data);
        if(data.status == 200){
          this.consultarStatusPlantilla()
        }
      },
      error => {
    });
  }

  consultarStatusPlantilla(){
    this.entradaService.consultarPlantilla()
    .pipe(first())
    .subscribe(
      data => {
        // console.log("consultar status es");
        // console.log(data);
        // console.log(data.body)
        // console.log(data.status)
        // console.log(data.body["result"])
        if(data.status == 200){
          if(data.body["result"] == 200){
            this.url_descargar = data.body["url_descargar"];
            this.progress = false;
            this.descargar = true;
          }else{
            setTimeout(() =>
            {
              this.consultarStatusPlantilla();
            },3000);
          }
        }
      },
      error => {
    });
  }

  handleFileInput(files: FileList) {
    this.spinner = true;
    this.fileToUpload = files.item(0);
    // console.log("el file")
    // console.log(this.fileToUpload)
    this.fulfillmentService.getUploadURlXlsx(this.fileToUpload.type)
    .pipe(first())
    .subscribe(
      data => {
        // console.log("la data es");
        // console.log(data);
        // console.log(data.status)
        if(data.status == 200){
          this.subirAWS(data.body["data"], this.fileToUpload);
        }else{
          // console.log("entro en else")
        }
      },
      error => {
    });
  }

  subirAWS(response, fileToUpload){
    // console.log("entramos en subirAWS")
    // console.log(response)
    this.file_name = response.file_name
    // console.log("El file final es "+ this.file_name)
    // console.log(response.url)
    this.fulfillmentService.subirArchivoXLS(response.url, fileToUpload)
    .pipe(first())
    .subscribe(
      data => {
        // console.log("respondio aws")
        // console.log(data)
        this.enviado = false;
        this.spinner = false;
      },
      error => {
    });
  }

  enviarEntradaMasiva(){
    if(this.formFile.invalid){
      this.snackBar.open("Debes anexar el formato primero.", "OK", {
        duration: 3500,
      });
      return;
    }

    const dialogRef = this.dialog.open(DialogFechaMasiva, {
      width: '700px',
      minHeight: '400px',
      height: 'auto',
      maxHeight: '90vh',
      disableClose: true,
      data: {}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!result) return;

      this.enviado = true;
      this.spinner = true;
      this.entradaService.mandarEntrada(this.file_name, result.arrival_date, result.arrival_time_start, result.arrival_time_end)
      .pipe(first())
      .subscribe(
        data => {
          if(data.status == 200){
            this.consultarStatusMasivo();
          }
        },
        error => {
          this.spinner = false;
          this.enviado = false;
      });
    });
  }

  consultarStatusMasivo(){
    this.dataErrors = [];
    this.entradaService.consultarMasivo()
    .pipe(first())
    .subscribe(
      data => {
        // console.log("consultar status es");
        // console.log(data);
        // console.log(data.body)
        // console.log(data.status)
        // console.log(data.body["result"])
        if(data.status == 200){
          if(data.body["result"] == 200 || data.body["result"] == 201){
            this.consultarEntrada(data.body["entrada_token"]);
          }else if(data.body["result"] == 500){
            this.spinner = false;
            this.consultarErrores(data.body["entrada_token"]);
          }else{
            setTimeout(() =>
            {
              this.consultarStatusMasivo();
            },3000);
          }
        }
      },
      error => {
    });
  }

  consultarEntrada(entrada_token){
    // console.log("entrada es "+entrada_token)
    this.entradaService.consultarEntrada(entrada_token)
    .pipe(first())
    .subscribe(
      data => {
        // console.log("consultar Orden es");
        // console.log(data);
        if(data.status == 200){
          this.spinner = false;
          const dialogRef3 = this.dialog.open(DialogEntrada ,{width:'90vw', height: '90%',disableClose: false ,data: {params: data}});
          dialogRef3.afterClosed().subscribe(result => {
            // console.log("Cerramos el dialog");
            this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
              this.router.navigate(['/entradas']);
            });
          });
        }
      },
      error => {
    });
  }

  consultarErrores(entrada_token){
    this.entradaService.consultarErrores(entrada_token)
    .pipe(first())
    .subscribe(
      data => {
        if(data.status == 200){
          this.spinner = false;
          this.dataErrors = data.body["errores"];
        }
      },
      error => {
    });
  }

}


@Component({
  selector: 'dialog-fecha-masiva',
  templateUrl: './dialog-fecha-masiva.html',
})
export class DialogFechaMasiva implements OnInit {

  arrivalDateForm: FormControl;
  minDate: Date;
  slotsDisponibles: any[] = [];
  loadingSlots: boolean = false;
  selectedSlot: any = null;
  mensajeFechaValidacion: string = null;
  spinner: boolean = false;
  error: string = null;

  constructor(
    public dialogRef: MatDialogRef<DialogFechaMasiva>,
    private entradaService: EntradaService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.minDate = new Date();
  }

  ngOnInit() {
    this.arrivalDateForm = new FormControl({ value: '', disabled: false }, [Validators.required]);

    this.arrivalDateForm.valueChanges.subscribe(() => {
      this.onFechaChange();
    });
  }

  onFechaChange() {
    const fechaSeleccionada = this.arrivalDateForm.value;
    if (!fechaSeleccionada) return;

    const fechaString = this.formatDateForBackend(fechaSeleccionada);

    this.slotsDisponibles = [];
    this.selectedSlot = null;
    this.mensajeFechaValidacion = null;
    this.error = null;

    this.loadingSlots = true;
    this.entradaService.validarFechaLlegada(fechaString)
      .pipe(first())
      .subscribe(
        data => {
          if (data.status == 200 && data.body) {
            const validacion = data.body;
            if (validacion.valido) {
              this.cargarSlots(fechaString);
            } else {
              this.mensajeFechaValidacion = validacion.mensaje;
              this.loadingSlots = false;
            }
          }
        },
        error => {
          this.mensajeFechaValidacion = 'Error al validar la fecha';
          this.loadingSlots = false;
        }
      );
  }

  cargarSlots(fecha: string) {
    this.entradaService.obtenerSlotsDisponibles(fecha)
      .pipe(first())
      .subscribe(
        data => {
          if (data.status == 200 && data.body) {
            const slots = data.body.slots_disponibles || [];
            this.slotsDisponibles = slots.filter(slot => slot.disponible !== false);
            if (this.slotsDisponibles.length === 0) {
              this.mensajeFechaValidacion = 'No hay horarios disponibles para la fecha seleccionada';
            }
          }
          this.loadingSlots = false;
        },
        error => {
          this.mensajeFechaValidacion = 'Error al cargar horarios disponibles';
          this.loadingSlots = false;
        }
      );
  }

  onSlotSelect(slot: any) {
    this.selectedSlot = slot;
    this.error = null;
  }

  confirmar() {
    if (!this.arrivalDateForm.value || !this.selectedSlot) {
      this.error = 'Por favor selecciona una fecha y un horario disponible';
      return;
    }
    const arrival_date = this.formatDateForBackend(this.arrivalDateForm.value);
    this.dialogRef.close({
      arrival_date,
      arrival_time_start: this.selectedSlot.hora_inicio,
      arrival_time_end: this.selectedSlot.hora_fin
    });
  }

  formatDateForBackend(date: Date | string): string {
    if (!date) return null;
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

}


@Component({
  selector: 'dialog-guia',
  templateUrl: './dialog-guia.html',
})
export class DialogGuia {

  guiaForm: FormGroup;
  loading = false;
  submitted = false;
  returnUrl: string;
  error: string;
  la_guia: string;
  mensaje_success = false;
  guiaFormGuia: FormControl;
  formPaqueteria: FormControl;
  paqueteriaFormGuia: FormControl;
  spinner = false;
  entrada_token: string;
  keywords = "";
  otra = false;
  paqueteria: string;

  constructor(
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<DialogGuia>,
    private entradaService: EntradaService,
    @Inject(MAT_DIALOG_DATA) public data: any
    ){
    if(this.data.token){
      this.entrada_token = this.data.token;
      // console.log("El token es "+this.entrada_token);
    }
  }

  ngOnInit(){
    this.guiaForm = this.formBuilder.group({
      guiaFormGuia: ['', Validators.required],
    });

    this.guiaFormGuia = new FormControl('', [
      Validators.required,
    ]);

    this.formPaqueteria = new FormControl('', [
      Validators.required,
    ]);

    this.paqueteriaFormGuia = new FormControl('', [Validators.required]);
  }

  seleccionar(){
    if(this.formPaqueteria.value == "otro"){
      this.otra = true;
    }else{
      this.otra = false;
    }
  }

  guardarGuia(){
    if (this.guiaFormGuia.invalid || this.formPaqueteria.invalid || (this.otra && this.paqueteriaFormGuia.invalid)){
      // console.log("campos invalidos");
      return;
    }
    this.loading = true;
    this.spinner = true;

    this.mensaje_success = true;
    this.loading = false;
    this.spinner = false;

    // console.log(this.guiaFormGuia.value)
    // console.log(this.formPaqueteria.value)
    if(this.otra){
      this.paqueteria = this.paqueteriaFormGuia.value;
    }else{
      this.paqueteria = this.formPaqueteria.value;
    }
    this.entradaService.actualizarEntrada(this.entrada_token, this.guiaFormGuia.value, this.paqueteria)
    .pipe(first())
    .subscribe(
      data => {
        // console.log("la data es");
        // console.log(data);
        // console.log(data.status)
        // console.log(data.body["message"]);
        if(data.status == 200){
          this.mensaje_success = true;
          this.loading = false;
          this.spinner = false;
        }else{
          this.error = data.body["message"];
          this.loading = false;
          this.spinner = false;
        }
      },
      error => {
        this.error = error;
        this.loading = false;
        this.spinner = false;
   });
  }

}




@Component({
  selector: 'dialog-guia-2',
  templateUrl: './dialog-guia-2.html',
})
export class DialogGuia2 {

  guiaForm: FormGroup;
  loading = false;
  submitted = false;
  returnUrl: string;
  error: string;
  la_guia: string;
  mensaje_success = false;
  guiaFormGuia: FormControl;
  formPaqueteria: FormControl;
  paqueteriaFormGuia: FormControl;
  checkForm: FormControl;
  checkApoyo: FormControl;
  spinner = false;
  entrada_token: string;
  entrada_final: object;
  keywords = "";
  otra = false;
  paqueteria: string;
  usuario: string;
  checked = true;
  num_guia: string;
  arrivalDateForm: FormControl;
  arrivalTimeStartForm: FormControl;
  arrivalTimeEndForm: FormControl;
  appointmentDurationMinutes: number = 120; // Valor por defecto de 2 horas
  minDate: Date;
  
  // Variables para la funcionalidad de slots
  slotsDisponibles: any[] = [];
  loadingSlots: boolean = false;
  selectedSlot: any = null;
  mensajeFechaValidacion: string = null;

  constructor(
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<DialogGuia2>,
    private entradaService: EntradaService,
    private authenticationService: AuthenticationService,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any
    ){
    if(this.data.entrada_final){
      this.entrada_final = this.data.entrada_final;
      // console.log(this.data.entrada_final)
    }

    this.authenticationService.currentUser.subscribe(x => this.usuario = x);
    // console.log("el rol es ");
    // console.log(this.usuario);
    // console.log("fin del rol")
    // console.log(this.authenticationService.currentRole)
    if(this.usuario){
      this.usuario = this.usuario['seller_id'];
    }
    // Establecer fecha mínima como hoy
    this.minDate = new Date();
  }

  ngOnInit(){
    this.guiaForm = this.formBuilder.group({
      guiaFormGuia: ['', Validators.required],
    });

    this.guiaFormGuia = new FormControl({value: '', disabled: false}, [
      Validators.required,
    ]);

    this.formPaqueteria = new FormControl({value: '', disabled: false}, [
      Validators.required,
    ]);

    this.paqueteriaFormGuia = new FormControl({value: '', disabled: false}, [Validators.required]);

    this.checkForm = new FormControl('', []);
    this.checkForm.setValue(false);

    this.checkApoyo = new FormControl('', []);
    this.checkApoyo.setValue(false);

    // Campos de fecha y hora de llegada
    this.arrivalDateForm = new FormControl({value: '', disabled: false}, [
      Validators.required,
    ]);

    this.arrivalTimeStartForm = new FormControl({value: '', disabled: false}, [
      Validators.required,
    ]);

    this.arrivalTimeEndForm = new FormControl({value: '', disabled: true}, []);

    // Cargar configuración de inbound_settings
    this.cargarInboundSettings();

    // Suscribirse a cambios en la hora de inicio para calcular automáticamente la hora de fin
    this.arrivalTimeStartForm.valueChanges.subscribe(() => {
      this.calcularHoraFin();
    });
    
    // Suscribirse a cambios en la fecha para validar y cargar slots
    this.arrivalDateForm.valueChanges.subscribe(() => {
      this.onFechaChange();
    });
  }

  cargarInboundSettings(){
    this.entradaService.consultarInboundSettings()
    .pipe(first())
    .subscribe(
      data => {
        if(data.status == 200 && data.body){
          const settings = data.body;
          if(settings.default_appointment_duration_minutes){
            this.appointmentDurationMinutes = settings.default_appointment_duration_minutes;
          }
        }
      },
      error => {
        // Si hay error, usar el valor por defecto
        console.log('Error al cargar inbound_settings, usando valor por defecto');
      }
    );
  }

  calcularHoraFin(){
    if(this.arrivalTimeStartForm.value){
      const [hours, minutes] = this.arrivalTimeStartForm.value.split(':').map(Number);
      const startDate = new Date();
      startDate.setHours(hours, minutes, 0, 0);
      
      // Agregar los minutos de duración
      const endDate = new Date(startDate.getTime() + (this.appointmentDurationMinutes * 60 * 1000));
      
      // Formatear la hora de fin (HH:MM)
      const endHours = endDate.getHours().toString().padStart(2, '0');
      const endMinutes = endDate.getMinutes().toString().padStart(2, '0');
      this.arrivalTimeEndForm.setValue(`${endHours}:${endMinutes}`);
    }

    // Suscribirse a cambios en los campos para limpiar el error cuando el usuario modifique algo
    this.setupFormChangeListeners();
  }

  setupFormChangeListeners(){
    // Limpiar error cuando el usuario modifica cualquier campo
    this.guiaFormGuia.valueChanges.subscribe(() => {
      this.limpiarError();
    });

    this.formPaqueteria.valueChanges.subscribe(() => {
      this.limpiarError();
    });

    this.paqueteriaFormGuia.valueChanges.subscribe(() => {
      this.limpiarError();
    });

    this.checkForm.valueChanges.subscribe(() => {
      this.limpiarError();
    });
  }

  limpiarError(){
    if(this.error){
      this.error = null;
    }
    if(this.mensajeFechaValidacion){
      this.mensajeFechaValidacion = null;
    }
  }
  
  // Método para validar fecha cuando el usuario la selecciona
  onFechaChange(){
    const fechaSeleccionada = this.arrivalDateForm.value;
    if(!fechaSeleccionada) return;
    
    const fechaString = this.formatDateForBackend(fechaSeleccionada);
    
    // Limpiar slots anteriores
    this.slotsDisponibles = [];
    this.selectedSlot = null;
    this.arrivalTimeStartForm.setValue('');
    this.arrivalTimeEndForm.setValue('');
    this.mensajeFechaValidacion = null;
    this.limpiarError();
    
    // Validar fecha
    this.loadingSlots = true;
    this.entradaService.validarFechaLlegada(fechaString)
    .pipe(first())
    .subscribe(
      data => {
        if(data.status == 200 && data.body){
          const validacion = data.body;
          
          if(validacion.valido){
            // Fecha válida, cargar slots
            this.cargarSlots(fechaString);
          } else {
            // Fecha inválida, mostrar mensaje
            this.mensajeFechaValidacion = validacion.mensaje;
            this.loadingSlots = false;
          }
        }
      },
      error => {
        this.mensajeFechaValidacion = "Error al validar la fecha";
        this.loadingSlots = false;
      }
    );
  }
  
  // Método para cargar slots disponibles
  cargarSlots(fecha: string){
    this.entradaService.obtenerSlotsDisponibles(fecha)
    .pipe(first())
    .subscribe(
      data => {
        if(data.status == 200 && data.body){
          // Filtrar solo slots con espacios disponibles (el backend ya lo hace, pero por seguridad)
          const slots = data.body.slots_disponibles || [];
          this.slotsDisponibles = slots.filter(slot => slot.disponible !== false);
          
          if(this.slotsDisponibles.length === 0){
            this.mensajeFechaValidacion = "No hay horarios disponibles para la fecha seleccionada";
          }
        }
        this.loadingSlots = false;
      },
      error => {
        this.mensajeFechaValidacion = "Error al cargar horarios disponibles";
        this.loadingSlots = false;
      }
    );
  }
  
  // Método cuando el usuario selecciona un slot
  onSlotSelect(slot: any){
    this.selectedSlot = slot;
    this.arrivalTimeStartForm.setValue(slot.hora_inicio);
    this.arrivalTimeEndForm.setValue(slot.hora_fin);
    this.limpiarError();
  }

  seleccionar(){
    if(this.formPaqueteria.value == "otro"){
      this.otra = true;
    }else{
      this.otra = false;
    }
    // Limpiar error cuando el usuario cambia la paquetería
    this.limpiarError();
  }

  reload(){
    this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
        this.router.navigate(['/entradas']);
    });
  }

  guardarEntrada(){
    // Validar que se haya seleccionado un slot
    if(!this.selectedSlot){
      this.error = "Por favor selecciona un horario disponible";
      return;
    }
    
    // Validar campos de fecha y hora
    if (this.arrivalDateForm.invalid || this.arrivalTimeStartForm.invalid){
      return;
    }

    if (this.guiaFormGuia.invalid || this.formPaqueteria.invalid || (this.otra && this.paqueteriaFormGuia.invalid)){
      if(this.checkForm.value){
        // console.log("No hay guia");
      }else{
        // console.log("campos invalidos");
        return;
      }
    }
    this.loading = true;
    this.spinner = true;

    this.mensaje_success = true;
    this.loading = false;
    this.spinner = false;

    // console.log(this.guiaFormGuia.value)
    // console.log(this.formPaqueteria.value)
    if(this.otra){
      this.paqueteria = this.paqueteriaFormGuia.value;
    }else{
      this.paqueteria = this.formPaqueteria.value;
    }
    this.num_guia = this.guiaFormGuia.value;
    if(this.checkForm.value){
      this.paqueteria = null;
      this.num_guia = null;
    }

    // Preparar fecha y horas para enviar al backend
    const arrival_date = this.arrivalDateForm.value ? this.formatDateForBackend(this.arrivalDateForm.value) : null;
    const arrival_time_start = normalizeTimeForBackend(this.arrivalTimeStartForm.value);
    const arrival_time_end = normalizeTimeForBackend(this.arrivalTimeEndForm.value);

    this.entradaService.enviarEntrada(
      this.data.entrada_final, 
      this.num_guia, 
      this.paqueteria, 
      this.usuario, 
      this.checkApoyo.value,
      arrival_date,
      arrival_time_start,
      arrival_time_end
    )
    .pipe(first())
    .subscribe(
      data => {
        // console.log("la data es");
        // console.log(data);
        // console.log(data.status)
        // console.log(data.body["message"]);
        if(data.status == 200){
          this.mensaje_success = true;
          this.error = null;
          this.loading = false;
          this.spinner = false;
        }else{
          this.error = data.body && data.body["message"] ? data.body["message"] : "Error desconocido";
          this.mensaje_success = false;
          this.loading = false;
          this.spinner = false;
        }
      },
      error => {
        // El ErrorInterceptor puede transformar el error a un string, o puede ser el objeto completo
        let errorMessage = null;
        
        // Si el error es un string (transformado por el interceptor)
        if(typeof error === 'string'){
          errorMessage = error;
        }
        // Si el error es un objeto HttpErrorResponse
        else if(error.status == 422){
          // Error 422: validación de capacidad de muelles
          if(error.error && error.error.message){
            errorMessage = error.error.message;
          } else if(error.error && typeof error.error === 'string'){
            errorMessage = error.error;
          } else if(error.error && error.error.status && error.error.message){
            errorMessage = error.error.message;
          } else {
            errorMessage = "Error de validación: No hay capacidad disponible en los muelles para la fecha y hora seleccionadas.";
          }
        } 
        // Otros errores HTTP
        else if(error.error){
          if(error.error.message){
            errorMessage = error.error.message;
          } else if(typeof error.error === 'string'){
            errorMessage = error.error;
          } else if(error.error.status && error.error.message){
            errorMessage = error.error.message;
          }
        }
        // Si no se pudo extraer el mensaje, usar mensajes por defecto
        if(!errorMessage){
          if(error.message){
            errorMessage = error.message;
          } else {
            errorMessage = "Hubo un error al intentar guardar la entrada. Por favor, intente nuevamente.";
          }
        }
        
        this.error = errorMessage;
        this.mensaje_success = false;
        this.loading = false;
        this.spinner = false;
   });
  }

  formatDateForBackend(date: Date | string): string {
    if (!date) return null;
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

}




export interface InboundEvent {
  id: number;
  fecha_evento: string;
  status: string;
  substatus: string;
  description: string;
  comentarios: string;
  nombre_usuario: string;
}

@Component({
  selector: 'dialog-entrada',
  templateUrl: './dialog-entrada.html',
  styleUrls: ['./entradas.component.scss'],
})
export class DialogEntrada {
  params: EntradaShowResponseBody | null = null;
  usuario: string;
  datos_tabla: ShowEntrada[] = [];
  datos_tabla_historial: InboundEvent[] = [];
  displayedColumns = ['titulo', 'seller_sku', 'ean', 'upc', 'cantidad_anunciada', 'cantidad_recibida','presale_stock'];
  displayedColumnsHistorial = ['fecha_evento', 'status', 'substatus', 'description', 'nombre_usuario'];
  progress = false;
  descargar = false;
  entrada_token: string;
  url_descargar: "";
  current_user: any;

  constructor(
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<DialogEntrada>,
    private authenticationService: AuthenticationService,
    private router: Router,
    private entradaService: EntradaService,
    @Inject(MAT_DIALOG_DATA) public data: any
    ){
    if(this.data.params){
      this.params = this.data.params.body as EntradaShowResponseBody;
      this.datos_tabla = this.params.esta_entrada;
      this.entrada_token = this.params.entrada_list.entrada_token;
      this.datos_tabla = this.datos_tabla.filter((value,key)=>{
        return value;
      });
    }

    this.authenticationService.currentUser.subscribe(x => this.usuario = x);
    // console.log("el rol es ");
    // console.log(this.usuario);
    // console.log("fin del rol")
    // console.log(this.authenticationService.currentRole)
    if(this.usuario){
      this.usuario = this.usuario['seller_id'];
    }
  }

  ngOnInit(){
    this.asignarDatos();
    this.cargarHistorialEventos();
  }

  cargarHistorialEventos(){
    this.entradaService.consultarInboundEvents(this.entrada_token)
    .pipe(first())
    .subscribe(
      data => {
        const body = data.body as InboundEventsResponseBody;
        if(data.status == 200 && body.inbound_events){
          this.datos_tabla_historial = body.inbound_events;
        }
      },
      error => {
        console.error("Error al cargar historial de eventos:", error);
      });
  }
  asignarDatos(){
    this.current_user = this.authenticationService.currentUserValue

  }
  validar_roles(clave_modulo){
    return this.authenticationService.validar_roles(clave_modulo,this.current_user.permisos);
  }

  generarEtiqueta(){
    this.progress = true;
    this.entradaService.generarEtiqueta(this.entrada_token)
    .pipe(first())
    .subscribe(
      data => {
        // console.log(data);
        if(data.status == 200){
          this.consultarStatusEtiqueta(this.entrada_token)
        }
      },
      error => {
    });
  }

  consultarStatusEtiqueta(entrada_token){
    this.entradaService.consultarEtiquetas(entrada_token)
    .pipe(first())
    .subscribe(
      data => {
        // console.log("consultar status es");
        // console.log(data);
        // console.log(data.body)
        // console.log(data.status)
        // console.log(data.body["result"])
        if(data.status == 200){
          if(data.body["result"] == 200){
            this.url_descargar = data.body["url_descargar"];
            this.progress = false;
            this.descargar = true;
          }else{
            setTimeout(() =>
            {
              this.consultarStatusEtiqueta(entrada_token);
            },3000);
          }
        }
      },
      error => {
    });
  }

  getTotalCantAnun() {
    return this.datos_tabla.map(t => t.cantidad_anunciada).reduce((acc, value) => acc + value, 0);
  }

  getTotalCantRec() {
    return this.datos_tabla.map(t => t.cantidad_recibida).reduce((acc, value) => acc + value, 0);
  }

  formatMexicoDateTime(value: string | null): string {
    return formatMexicoDateTime(value);
  }

  getTotalPreventa() {
    return this.datos_tabla.map(t => t.presale_stock || 0).reduce((acc, value) => acc + value, 0);
  }

}
export interface EntradaError {
  seller_sku: string;
  title: string;
  result: string;
  code: string;
}


// Componente para editar entradas (productos y fecha/hora)
@Component({
  selector: 'dialog-editar-entrada',
  templateUrl: './dialog-editar-entrada.html',
  styleUrls: ['./entradas.component.scss'],
})
export class DialogEditarEntrada implements OnInit {
  entradaToken: string;
  permisos: any;
  productos: any[] = [];
  productosOriginales: any[] = [];
  productosEliminados: any[] = [];
  dataSourceProductos: MatTableDataSource<any>;
  
  // Estado
  loading = false;
  loadingProductos = false;
  error: string | null = null;
  mensaje_success = false;
  
  // Slots disponibles
  slotsDisponibles: any[] = [];
  selectedSlot: any = null;
  loadingSlots = false;
  mensajeFechaValidacion: string = null;
  
  // Forms
  arrivalDateForm: FormControl;
  arrivalTimeStartForm: FormControl;
  arrivalTimeEndForm: FormControl;
  minDate: Date;
  
  // Campos para agregar productos
  itemForm: FormControl;
  cantidadForm: FormControl;
  entradaDatabase: EntradaDatabaseItems | null;
  dataItems: ItemsIssue[] = [];
  isLoadingResults = false;
  keywords = "";
  
  // Columnas de la tabla de productos
  displayedColumns = ['seller_sku', 'titulo', 'ean', 'cantidad_anunciada', 'preventa', 'action'];
  
  constructor(
    public dialogRef: MatDialogRef<DialogEditarEntrada>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    private entradaService: EntradaService,
    private snackBar: MatSnackBar,
    private router: Router,
    private _httpClient: HttpClient
  ) {
    this.entradaToken = data.entrada_token;
    this.permisos = data.permisos || {};
    this.minDate = new Date();
    
    // Inicializar el dataSource
    this.dataSourceProductos = new MatTableDataSource<any>([]);
  }
  
  ngOnInit() {
    // Inicializar formularios
    this.inicializarFormularios();
    
    // Inicializar base de datos de items para autocomplete
    this.entradaDatabase = new EntradaDatabaseItems(this._httpClient);
    this.hacerAutcomplete(this.keywords);
    
    // Cargar productos de la entrada
    this.cargarProductos();
    
    // Si ya tiene fecha programada, cargar los slots automáticamente
    if (this.permisos.puede_editar_fecha_hora && this.permisos.fecha_programada) {
      // Usar setTimeout para asegurar que el formulario esté completamente inicializado
      setTimeout(() => {
        this.cargarSlotsInicial();
      }, 100);
    }
  }
  
  inicializarFormularios() {
    // Convertir fecha string a Date object si existe
    let fechaInicial = null;
    if (this.permisos.fecha_programada) {
      fechaInicial = new Date(this.permisos.fecha_programada + 'T00:00:00');
    }
    
    // Form para fecha y hora
    this.arrivalDateForm = new FormControl(
      {value: fechaInicial || '', disabled: !this.permisos.puede_editar_fecha_hora}, 
      [Validators.required]
    );
    
    this.arrivalTimeStartForm = new FormControl(
      {value: this.permisos.hora_inicio_programada || '', disabled: true}, 
      [Validators.required]
    );
    
    this.arrivalTimeEndForm = new FormControl(
      {value: this.permisos.hora_fin_programada || '', disabled: true}, 
      []
    );
    
    // Forms para agregar productos
    this.itemForm = new FormControl('', [Validators.required]);
    this.cantidadForm = new FormControl('', [Validators.required, Validators.min(1)]);
    
    // Suscribirse a cambios en la fecha para validar y cargar slots
    this.arrivalDateForm.valueChanges.subscribe(() => {
      this.onFechaChange();
    });
  }
  
  cargarProductos() {
    this.loadingProductos = true;
    this.entradaService.consultarEntrada(this.entradaToken)
      .pipe(first())
      .subscribe(
        data => {
          if (data.status === 200 && data.body) {
            // Crear un nuevo array con copias de los productos
            const productosArray = data.body.esta_entrada.map(p => ({
              id: p.id,
              entrada_id: p.id,
              item_id: p.item_id,
              seller_sku: p.seller_sku,
              titulo: p.titulo,
              ean: p.ean,
              upc: p.upc,
              cantidad_anunciada: p.cantidad_anunciada,
              cantidad_recibida: p.cantidad_recibida,
              presale_stock: p.presale_stock,
              presale: p.presale === true,
              es_nuevo: false
            }));
            
            // Asignar como un nuevo array
            this.productos = [...productosArray];
            
            // Actualizar el dataSource
            this.dataSourceProductos.data = this.productos;
            
            // Guardar copia de originales para detectar cambios
            this.productosOriginales = JSON.parse(JSON.stringify(this.productos));
          }
          this.loadingProductos = false;
        },
        error => {
          this.error = 'Error al cargar productos';
          this.loadingProductos = false;
        }
      );
  }
  
  onFechaChange() {
    const fechaSeleccionada = this.arrivalDateForm.value;
    if (!fechaSeleccionada) return;
    
    const fechaString = this.formatDateForBackend(fechaSeleccionada);
    
    // Limpiar slots anteriores
    this.slotsDisponibles = [];
    this.selectedSlot = null;
    this.arrivalTimeStartForm.setValue('');
    this.arrivalTimeEndForm.setValue('');
    this.mensajeFechaValidacion = null;
    this.limpiarError();
    
    // Validar fecha
    this.loadingSlots = true;
    this.entradaService.validarFechaLlegada(fechaString)
      .pipe(first())
      .subscribe(
        data => {
          if (data.status === 200 && data.body) {
            const validacion = data.body;
            
            if (validacion.valido) {
              // Fecha válida, cargar slots
              this.cargarSlots(fechaString);
            } else {
              // Fecha inválida, mostrar mensaje
              this.mensajeFechaValidacion = validacion.mensaje;
              this.loadingSlots = false;
            }
          }
        },
        error => {
          this.mensajeFechaValidacion = "Error al validar la fecha";
          this.loadingSlots = false;
        }
      );
  }
  
  // Método para cargar slots al inicializar con fecha programada
  cargarSlotsInicial() {
    if (!this.permisos.fecha_programada) return;
    
    const fechaString = this.permisos.fecha_programada;
    
    // Validar fecha y cargar slots
    this.loadingSlots = true;
    this.entradaService.validarFechaLlegada(fechaString)
      .pipe(first())
      .subscribe(
        data => {
          if (data.status === 200 && data.body) {
            const validacion = data.body;
            
            if (validacion.valido) {
              // Fecha válida, cargar slots
              this.cargarSlots(fechaString);
            } else {
              // Fecha inválida, mostrar mensaje
              this.mensajeFechaValidacion = validacion.mensaje;
              this.loadingSlots = false;
            }
          }
        },
        error => {
          this.mensajeFechaValidacion = "Error al validar la fecha";
          this.loadingSlots = false;
        }
      );
  }
  
  cargarSlots(fecha: string) {
    // Pasar el entrada_token para excluir esta entrada del conteo de capacidad
    this.entradaService.obtenerSlotsDisponibles(fecha, this.entradaToken)
      .pipe(first())
      .subscribe(
        data => {
          if (data.status === 200 && data.body) {
            const slots = data.body.slots_disponibles || [];
            this.slotsDisponibles = slots.filter(slot => slot.disponible !== false);
            
            // Pre-seleccionar el slot actual si existe
            if (this.permisos.hora_inicio_programada && this.permisos.hora_fin_programada) {
              const slotActual = this.slotsDisponibles.find(s => 
                s.hora_inicio === this.permisos.hora_inicio_programada &&
                s.hora_fin === this.permisos.hora_fin_programada
              );
              if (slotActual) {
                this.selectedSlot = slotActual;
                this.arrivalTimeStartForm.setValue(slotActual.hora_inicio);
                this.arrivalTimeEndForm.setValue(slotActual.hora_fin);
              }
            }
            
            if (this.slotsDisponibles.length === 0) {
              this.mensajeFechaValidacion = "No hay horarios disponibles para la fecha seleccionada";
            }
          }
          this.loadingSlots = false;
        },
        error => {
          this.mensajeFechaValidacion = "Error al cargar horarios disponibles";
          this.loadingSlots = false;
        }
      );
  }
  
  onSlotSelect(slot: any) {
    this.selectedSlot = slot;
    this.arrivalTimeStartForm.setValue(slot.hora_inicio);
    this.arrivalTimeEndForm.setValue(slot.hora_fin);
    this.limpiarError();
  }
  
  limpiarError() {
    if (this.error) {
      this.error = null;
    }
    if (this.mensajeFechaValidacion) {
      this.mensajeFechaValidacion = null;
    }
  }
  
  // Funciones para gestionar productos
  hacerAutcomplete(filtros: string) {
    merge()
    .pipe(
      startWith({}),
      switchMap(() => {
        this.isLoadingResults = true;
        return this.entradaDatabase!.getRepoIssues(filtros);
      }),
      map(data => {
        this.isLoadingResults = false;
        return data.items;
      }),
      catchError(() => {
        this.isLoadingResults = false;
        return observableOf([]);
      })
    ).subscribe(data => this.dataItems = data);
  }
  
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.keywords = filterValue.trim().toLowerCase();
    this.hacerAutcomplete(this.keywords);
  }
  
  displayFn(subject: any) {
    if (subject) {
      if (subject.seller_sku) {
        return subject.seller_sku;
      } else if (subject.title) {
        return subject.title;
      }
    }
    return undefined;
  }
  
  validarDatos() {
    if (this.itemForm.invalid || this.cantidadForm.invalid) {
      return;
    }
    
    const elItem = this.itemForm.value;
    if (!elItem) {
      return;
    }
    
    if (!(typeof elItem === 'object' && elItem !== null)) {
      this.snackBar.open("Debes seleccionar un producto de la lista", "OK", {
        duration: 5000,
      });
      return;
    }
    
    if (elItem.bundle && elItem.bundle > 0) {
      this.snackBar.open(`El SKU: ${elItem.seller_sku} es un bundle, no se le puede generar entrada de inventario`, "OK", {
        duration: 3500,
      });
      return;
    }
    
    // Agregar el producto a la lista
    this.addItem(elItem, this.cantidadForm.value);
    
    // Limpiar campos
    this.itemForm.setValue('');
    this.cantidadForm.setValue('');
    this.limpiarError();
  }
  
  addItem(item: any, cantidad: number) {
    // Verificar si el producto ya existe en la lista
    const found = this.productos.find(p => p.item_id === item.id);
    
    if (!found) {
      // Agregar nuevo producto - CREAR NUEVA REFERENCIA DEL ARRAY
      const nuevoProducto = {
        id: null, // Nuevo producto, no tiene entrada_id todavía
        entrada_id: null,
        item_id: item.id,
        seller_sku: item.seller_sku,
        titulo: item.title,
        ean: item.ean || '',
        upc: item.upc || '',
        cantidad_anunciada: cantidad,
        cantidad_recibida: 0,
        presale_stock: 0,
        presale: false,
        es_nuevo: true // Marcador para identificar productos nuevos
      };
      
      // Crear una nueva referencia del array para que Angular detecte el cambio
      this.productos = [...this.productos, nuevoProducto];
      
      // Actualizar el dataSource
      this.dataSourceProductos.data = this.productos;
      
      this.snackBar.open(`Producto ${item.seller_sku} agregado`, "OK", {
        duration: 2000,
      });
    } else {
      // Incrementar cantidad del producto existente
      found.cantidad_anunciada += cantidad;
      
      // Crear nueva referencia del array para forzar detección de cambios
      this.productos = [...this.productos];
      
      // Actualizar el dataSource
      this.dataSourceProductos.data = this.productos;
      
      this.snackBar.open(`Cantidad actualizada para ${item.seller_sku}`, "OK", {
        duration: 2000,
      });
    }
  }
  
  deleteRowData(producto: any) {
    // Si es un producto existente (tiene entrada_id), agregarlo a la lista de eliminados
    if (producto.entrada_id && !producto.es_nuevo) {
      this.productosEliminados.push(producto);
    }
    
    // Eliminar de la lista de productos - CREAR NUEVA REFERENCIA DEL ARRAY
    this.productos = this.productos.filter(p => {
      if (p.entrada_id) {
        return p.entrada_id !== producto.entrada_id;
      } else {
        // Para productos nuevos, comparar por item_id y referencia
        if (p.item_id === producto.item_id && p === producto) {
          return false;
        }
        return true;
      }
    });
    
    // Actualizar el dataSource
    this.dataSourceProductos.data = this.productos;
    
    this.snackBar.open(`Producto ${producto.seller_sku} eliminado`, "OK", {
      duration: 2000,
    });
    this.limpiarError();
  }
  
  // Función trackBy para mejorar el rendimiento de la tabla
  trackByProducto(index: number, producto: any): any {
    // Si tiene entrada_id, usarlo como identificador único
    if (producto.entrada_id) {
      return producto.entrada_id;
    }
    // Si es nuevo, usar una combinación de item_id e index
    return `${producto.item_id}_${index}`;
  }
  
  guardarCambios() {
    if (this.loading) return;
    
    this.loading = true;
    this.error = null;
    this.mensaje_success = false;
    
    // Preparar lista completa de productos para enviar
    const productosParaEnviar = [];
    if (this.permisos.puede_editar_productos) {
      // Productos nuevos (agregar)
      const productosNuevos = this.productos.filter(p => p.es_nuevo || !p.entrada_id);
      productosNuevos.forEach(p => {
        productosParaEnviar.push({
          item_id: p.item_id,
          cantidad_anunciada: p.cantidad_anunciada,
          presale: p.presale === true,
          accion: 'agregar'
        });
      });
      
      // Productos existentes modificados (actualizar)
      this.productos.forEach(productoActual => {
        if (!productoActual.es_nuevo && productoActual.entrada_id) {
          const productoOriginal = this.productosOriginales.find(p => p.id == productoActual.id);
          const presaleActual = productoActual.presale === true;
          const presaleOriginal = productoOriginal ? (productoOriginal.presale === true) : false;
          const cantidadCambio = productoOriginal && productoActual.cantidad_anunciada !== productoOriginal.cantidad_anunciada;
          const presaleCambio = presaleActual !== presaleOriginal;
          if (productoOriginal && (cantidadCambio || presaleCambio)) {
            productosParaEnviar.push({
              entrada_id: productoActual.entrada_id,
              cantidad_anunciada: productoActual.cantidad_anunciada,
              presale: productoActual.presale === true,
              accion: 'actualizar'
            });
          }
        }
      });
      
      // Productos eliminados (eliminar)
      this.productosEliminados.forEach(p => {
        productosParaEnviar.push({
          entrada_id: p.entrada_id,
          accion: 'eliminar'
        });
      });
    }
    
    // Detectar cambios en fecha/hora
    let fechaHoraCambiada = false;
    if (this.permisos.puede_editar_fecha_hora && this.arrivalDateForm.valid && this.selectedSlot) {
      const fechaActual = this.formatDateForBackend(this.arrivalDateForm.value);
      const horaInicioActual = normalizeTimeForBackend(this.arrivalTimeStartForm.value);
      const horaFinActual = normalizeTimeForBackend(this.arrivalTimeEndForm.value);
      const fechaCambiada = fechaActual !== this.permisos.fecha_programada ||
                           horaInicioActual !== this.permisos.hora_inicio_programada ||
                           horaFinActual !== this.permisos.hora_fin_programada;
      fechaHoraCambiada = fechaCambiada;
    }
    
    // Si no hay cambios
    if (productosParaEnviar.length === 0 && !fechaHoraCambiada) {
      this.snackBar.open('No hay cambios para guardar', 'Cerrar', { duration: 3000 });
      this.loading = false;
      return;
    }
    
    // Ejecutar actualización de productos
    let productosPromise = Promise.resolve(null);
    if (productosParaEnviar.length > 0) {
      productosPromise = this.entradaService.actualizarProductosEntrada(
        this.entradaToken,
        productosParaEnviar
      ).toPromise();
    }
    
    // Ejecutar actualización de fecha/hora
    let fechaHoraPromise = Promise.resolve(null);
    if (fechaHoraCambiada) {
      fechaHoraPromise = this.entradaService.actualizarFechaHoraEntrada(
        this.entradaToken,
        this.formatDateForBackend(this.arrivalDateForm.value),
        normalizeTimeForBackend(this.arrivalTimeStartForm.value),
        normalizeTimeForBackend(this.arrivalTimeEndForm.value)
      ).toPromise();
    }
    
    // Ejecutar todas las promesas
    Promise.all([productosPromise, fechaHoraPromise])
      .then((responses: any[]) => {
        // Verificar si todas fueron exitosas
        const errores = [];
        
        if (responses[0] && responses[0].status !== 200) {
          const mensaje = (responses[0].body && responses[0].body.message) ? responses[0].body.message : 'Error al actualizar productos';
          errores.push(mensaje);
        }
        
        if (responses[1] && responses[1].status !== 200) {
          const mensaje = (responses[1].body && responses[1].body.message) ? responses[1].body.message : 'Error al actualizar fecha/hora';
          errores.push(mensaje);
        }
        
        if (errores.length > 0) {
          this.error = errores.join('. ');
          this.loading = false;
        } else {
          this.mensaje_success = true;
          this.loading = false;
          this.snackBar.open('Cambios guardados exitosamente', 'Cerrar', {
            duration: 3000,
            panelClass: ['success-snackbar']
          });
          
          // Cerrar el diálogo después de 1 segundo
          setTimeout(() => {
            this.dialogRef.close(true);
          }, 1000);
        }
      })
      .catch(error => {
        // Manejar errores
        let errorMessage = 'Error al guardar cambios';
        
        if (error.status === 403) {
          errorMessage = (error.error && error.error.message) ? error.error.message : 'No tienes permisos para realizar esta acción';
        } else if (error.status === 422) {
          if (error.error && error.error.message) {
            errorMessage = error.error.message;
          } else if (error.error && error.error.errores) {
            errorMessage = error.error.errores.join(', ');
          }
        } else if (error.error && error.error.message) {
          errorMessage = error.error.message;
        }
        
        this.error = errorMessage;
        this.loading = false;
      });
  }
  
  formatDateForBackend(date: Date | string): string {
    if (!date) return '';
    
    // Si ya es un string en formato correcto, retornarlo
    if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
      return date;
    }
    
    // Convertir a Date y formatear
    const d = new Date(date);
    
    // Verificar que sea una fecha válida
    if (isNaN(d.getTime())) {
      return '';
    }
    
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
  
  cancelar() {
    this.dialogRef.close(false);
  }
  
  reload() {
    this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/entradas']);
    });
  }
}
